import { render, staticRenderFns } from "./customerDataAudit.vue?vue&type=template&id=4ab007d8"
import script from "./customerDataAudit.vue?vue&type=script&lang=js"
export * from "./customerDataAudit.vue?vue&type=script&lang=js"
import style0 from "./customerDataAudit.vue?vue&type=style&index=0&id=4ab007d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports